import "./Join01.css";

function Join01() {
  return (
    <div class="Join01 section" id="join">
      <div class="container">
        <div class="Join01-box cartoony">
          <h5>COMMUNITY</h5>
          <h2>Become a warrior!</h2>
          <p>
            Join our community of explorers, token holders, and puzzle solvers
            as we venture forth to reveal the secrets hidden beneath the sands
            of time. With $Zhǐwǔ, you're not just part of a project; you're on
            an epic quest to rediscover lost wisdom and technology.
          </p>
          <p>Will you accept the challenge?</p>

          <div class="btnFlex">
            <a href="" target="_blank" rel="noopener noreferrer">
              <button class="btn03">X/TWITTER</button>
            </a>
            <a href="" target="_blank" rel="noopener noreferrer">
              <button class="btn03">TELEGRAM</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Join01;
